import { lazy } from "react";

// โหลดหน้าแบบแยกไฟล์ (React.lazy) — ใช้คู่กับ <Suspense> ใน routes/navigation.js
// ถ้าไฟล์ของหน้าโหลดไม่ได้ (ChunkLoadError เช่นเปิดเว็บค้างไว้ตั้งแต่ก่อน deploy) ให้รีโหลดเว็บ 1 ครั้ง
// เพื่อรับ index.html ชุดใหม่ ถ้ารีโหลดแล้วยังไม่ได้ให้โยน error ตามปกติ (กันวนรีโหลดไม่จบ)
const RELOAD_KEY = "lazy_page_reloaded";

const isChunkError = (error) => /ChunkLoadError|Loading (CSS )?chunk/i.test(String(error && (error.name + " " + error.message)));

export default function lazyPage(factory) {
     return lazy(() =>
          factory()
               .then((module) => {
                    try {
                         sessionStorage.removeItem(RELOAD_KEY);
                    } catch (e) {}
                    return module;
               })
               .catch((error) => {
                    let reloaded = false;
                    try {
                         reloaded = sessionStorage.getItem(RELOAD_KEY) === "1";
                    } catch (e) {}
                    if (isChunkError(error) && !reloaded) {
                         try {
                              sessionStorage.setItem(RELOAD_KEY, "1");
                         } catch (e) {}
                         window.location.reload();
                         return new Promise(() => {});
                    }
                    throw error;
               })
     );
}
